import { createSelector } from 'reselect';

import { getUnattendedSkipLaborTicketFormEnabled } from './getUnattendedSkipLaborTicketFormEnabled';
import { getUnattendedOperatorPersonId } from './getUnattendedOperatorPersonId';

/*
  Returns a function telling whether signing out a personId skips the clock-out
  modal. With the Unattended form skipped, the shared Unattended operator signs
  out without it and is never clocked out: clocking it out would end its runs on
  every machine.
*/
const getIsClockOutModalSkipped = createSelector(
  [getUnattendedSkipLaborTicketFormEnabled, getUnattendedOperatorPersonId],
  (unattendedSkipForm, unattendedPersonId) => {
    return (personId) => {
      return (
        unattendedSkipForm &&
        !!unattendedPersonId &&
        personId === unattendedPersonId
      );
    };
  }
);

export { getIsClockOutModalSkipped };
